export class Response<T> {
  public data: T;
  public count: number;
  public now: string;
}
